<template>
	<div class="contain pad-x pt-32 lg-pt-44 pb-72 lg-pb-96 bg-gradient">
		<h1 class="mb-24 lg-mb-28 fs-26 lg-fs-32 fw-800">My Account</h1>
		<div class="account-layout">
			<aside>
				<nav class="account-nav card-v2">
					<router-link :to="{ name: $routes.AccountInfo.name }">Account Information</router-link>
					<router-link :to="{ name: $routes.AccountNotif.name }">Notification Preferences</router-link>
					<router-link :to="{ name: $routes.AccountPlan.name }">Plan and Payment Info</router-link>
					<router-link :to="{ name: $routes.PaymentHistory.name }">Payment History</router-link>
					<!-- <router-link :to="{ name: $routes.AccountRefer.name }">Refer a Friend</router-link> -->
				</nav>
			</aside>
			<main>
				<router-view/>
			</main>
		</div>
	</div>
</template>

<script>

export default {
  name: 'Account',
  components: {
  },
  computed: {
  },
  metaInfo: {
    title: 'My Account',
  },
};
</script>
